import React from 'react';
export function InterviewSection() {
  return <section className="space-y-10 text-lg leading-relaxed text-stone-800" data-id="element-67">
      {/* Question 1 */}
      <div className="space-y-4" data-id="element-68">
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-69">
          1 - Avedis, what inspired you to develop a product for healthy teeth
          and gums? Aren't there enough products in the aisles of supermarkets?
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/qJrr6WnH5WMwfghCs3AAZH/Slice_3_(2)_(1).png" alt="Nature article: Oral microbiome findings challenge dentistry dogma" className="w-full rounded-md" data-id="element-70" />
        <p data-id="element-71">
          It all started with my own experience. After 30+ years of seeing the
          same patients who did everything right but ended up in my chair over
          and over again, I decided to dig deeper.
        </p>
        <p data-id="element-72">
          <strong data-id="element-73">
            And what I found changed how I treat all of my patients...
          </strong>
        </p>
        <p data-id="element-74">
          Up until just a few years ago, the predominant thinking in dentistry
          was that people needed to keep the oral cavity 'clean' by getting rid
          of as many oral bacteria as possible.
        </p>
        <p data-id="element-75">
          But a 2021 study published in Nature - one of the most prestigious
          health articles - revealed that the very anti-microbial products we
          use that are designed to "protect" our teeth are in fact getting rid
          of the very healthy organisms our mouths rely on entirely.
        </p>
        <p data-id="element-76">
          How else can we explain the fact that our ancestors maintained
          perfectly healthy teeth thousands of years ago - without having any
          concept of toothbrushes or oral care?
        </p>
      </div>

      {/* Question 2 */}
      <div className="space-y-4" data-id="element-77">
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-78">
          2 - Wait — are you saying brushing is actually making things worse?
          Should people stop brushing and using mouthwash completely?
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/sSULrqfHwLBBgnRH34YDjv/Slice_4_(1).png" alt="Woman brushing teeth and oral bacteria microscopic view" className="w-full rounded-md" data-id="element-79" />
        <p data-id="element-80">
          <strong data-id="element-81">Avedis:</strong> Absolutely not. Even though conventional
          teeth products aren't designed to choose which kind of bacteria to
          eliminate, brushing and rinsing are still absolutely essential as they
          are your first line of defense for removing food debris and surface
          bacteria. Nothing replaces that.
        </p>
        <p className="font-[700]" data-id="element-82">
          What I AM saying is that every time you brush with an antibacterial
          toothpaste or rinse with mouthwash to rid of bad bacteria, you're
          accidentally depleting the very healthy bacteria your mouth needs to
          defend itself. Day after day. Year after year.
        </p>
        <p data-id="element-83">
          This is exactly why I kept seeing the same patients end up back in my
          chair with new problems just after a few months, even after doing
          everything I recommended them to do.
        </p>
        <p className="font-[700]" data-id="element-84">
          Their mouths didn't have too much bad bacteria… It had too little good
          bacteria…
        </p>
        <p className="font-[400]" data-id="element-85">
          What the "Clear and Guard Protocol" does is simple…
        </p>
        <p data-id="element-86">
          Instead of having to choose between modern dental hygiene and a
          healthy mouth, you just have to give your mouth the support it needs
          to thrive in spite of it.
        </p>
        <p data-id="element-87">
          Just one chew in the morning after you brush instantly floods your
          mouth with billions of healthy bacteria destroyed in the process,
          while also forming a smooth protective shield around your teeth which
          repels future harmful bacteria.
        </p>
      </div>

      {/* Question 3 */}
      <div className="space-y-4" data-id="element-88">
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-89">
          3 - I've tried oral probiotics before and they didn't do anything. Why
          would this be any different?
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/3YVfUVPLXn4Syz8UfHmsfC/Slice_5_(2).png" alt="Enamel before and after hydroxyapatite microscopic comparison" className="w-full rounded-md" data-id="element-90" />
        <p data-id="element-91">
          I was hoping you would ask this question, because this image shows why
          probiotics are only half the answer…
        </p>
        <p data-id="element-92">
          And that's exactly why they come in second in the "Clear and Guard"
          protocol.
        </p>
        <p data-id="element-93">
          See, while probiotics have widely been studied in gut health for
          years, they work differently when it comes to oral health.
        </p>
        <p data-id="element-94">
          First, you can't expect the healthy bacteria from a probiotic to climb
          back up your esophagus once a capsule is swallowed…
        </p>
        <p data-id="element-95">Instead, you need something specifically designed for the mouth.</p>
        <p className="font-[700]" data-id="element-96">
          And even if you do find that, the problem is probiotics can't
          physically rebuild your teeth or fill micro-cracks that bad bacteria
          have used to stay hidden for years.
        </p>
        <p data-id="element-97">
          The solution? You need to first create an environment where good
          bacteria can actually establish dominance.
        </p>
        <p data-id="element-98">
          And the only compound capable of doing that is the exact same mineral
          your teeth are already made of.
        </p>
        <p data-id="element-99">
          Microcrystalline hydroxyapatite derived exclusively from
          pasture-raised cattle in New Zealand and Australia — some of the most
          nutrient-rich pastures in the world.
        </p>
        <p className="font-[700]" data-id="element-100">
          In fact, a clinical study done in 2017 used microscopic scanning
          therapy to find teeth were significantly smoother and more intact
          after hydroxyapatite treatment compared to controls.
        </p>
        <p data-id="element-101">
          Without it, you're essentially just planting seeds in concrete when
          you take probiotics alone.
        </p>
        <p data-id="element-102">
          But once you combine healthy bacteria with this remarkable mineral,
          you're finally giving these seeds fertile soil to grow in.
        </p>
        <p data-id="element-103">
          In other words, ClearGuard Pro is not just a probiotic that "supports"
          healthy teeth and gums.
        </p>
        <p data-id="element-104">
          It's a first of its kind protocol that simultaneously rebuilds enamel
          and restores gum health at the biological level.
        </p>
      </div>

      {/* Question 4 Intro */}
      <div className="space-y-4" data-id="element-105">
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-106">
          4 - If the answer was this simple, why hasn't anyone done this before?
          And is it safe?
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/848NKkNF681G6AoRQh5okR/Slice_7_(1).png" alt="Scientist examining samples under microscope and mineral candy supplement" className="w-full rounded-md" data-id="element-107" />

        <p data-id="element-108">
          <strong data-id="element-109">Avedis:</strong> As a dentist, I have a responsibility to my
          patients. I would never point someone toward a product marketed online
          that may or may not contain the right ingredients, in the right doses,
          combined in the right way — let alone one I couldn't verify was even
          safe to put in their mouth.
        </p>
        <p data-id="element-110">
          That's not how I practice medicine and it's not something I'm willing
          to put my name behind.
        </p>
        <p data-id="element-111">But the research on these compounds was impossible to ignore.</p>
        <p className="font-[700]" data-id="element-112">
          Clinical study after clinical study showing the same results I was
          desperately trying to get for my own patients.
        </p>
        <p data-id="element-113">
          And unlike most of what you find on the market — the safety data was
          just as compelling as the efficacy data.
        </p>
        <p data-id="element-114">
          These compounds have been studied in pregnant women and children with
          no adverse effects…
        </p>
        <p data-id="element-115">
          That's not something you can say about most things people are already
          putting in their mouths.
        </p>
        <p data-id="element-116">So I had two choices….</p>
        <p data-id="element-117">
          I could either keep watching my patients lose the battle against their
          own teeth while the science sat in journals nobody was reading….
        </p>
        <p data-id="element-118">Or I could do something about it and formulate it myself…</p>
        <p data-id="element-119">
          So I went back to the research and designed ClearGuard Pro around six
          compounds that kept showing up in the literature — each one with a
          specific job to do.
        </p>
        <p data-id="element-120">And the result looks deceptively simple…</p>
        <p data-id="element-121">A small chew you dissolve in your mouth right after you brush.</p>
        <p data-id="element-122">Something that looks — and tastes — like candy.</p>
        <p className="font-[700]" data-id="element-123">
          But underneath that simplicity is a dual-action mechanism specifically
          engineered to do something no toothpaste, rinse, or probiotic has ever
          done simultaneously…
        </p>
        <p data-id="element-124">
          It fundamentally alters the oral environment at the biological level,
          transitioning it from a state of chronic vulnerability to one of
          physical and microbial resilience.
        </p>
        <p data-id="element-125">
          Not only that, but unlike anything else you've ever tried for your
          teeth — the benefits don't plateau.
        </p>
        <p data-id="element-126">Instead, every chew builds on the last…</p>
        <p data-id="element-127">
          This means the longer you use it, the stronger your enamel gets, the
          more established your mouth's biological guard becomes, and the harder
          it is for harmful bacteria to ever gain a foothold again.
        </p>
        <p className="font-[700]" data-id="element-128">
          Let me tell you exactly what these ingredients are now, and how they
          work.
        </p>
      </div>
    </section>;
}